import { message } from "antd";
import { DownloadItem } from "../../../types/interfaces";
import { getIdToken } from "../../userManager/userManagementUtils";
import { handleResponse } from "../../../common/handleLambdaResponse";


export const getDownloadList = (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Error fetching download list.");
            return
        }
        const params = {
            FunctionName: "download-requestor",
            Payload: JSON.stringify({
                action: "list",
                token: idToken
            })
        };

        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject);
        });
    });
};
export const singleDownload = (record: DownloadItem): Promise<string> => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Error fetching download.");
            return
        }
        const params = {
            FunctionName: "download-requestor",
            Payload: JSON.stringify({
                action: "download",
                download_id: record.download_id,
                token: idToken
            })
        };

        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject);
        });
    });
};

export const deleteDownload = (record: DownloadItem) : Promise<string> => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Error deleting download.");
            return
        }
        const params = {
            FunctionName: "download-requestor",
            Payload: JSON.stringify({
                action: "delete",
                download_id: record.download_id,
                token: idToken
            })
        };

        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject);
        });
    })
};

export const batchDownload = (inDownloadIds: string[]): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Error downloading multiple files.");
            return
        }
        const params = {
            FunctionName: "download-requestor",
            Payload: JSON.stringify({
                action: "batch_download",
                download_ids: inDownloadIds,
                token: idToken
            })
        };

        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject);
        });
    })
};